import { ReactNode } from "react";
import Box from "@mui/material/Box";

export const highlightText = (text: string, searchTerm: string): ReactNode => {
  if (!searchTerm || !text) return text;

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <Box
        component="span"
        key={index}
        sx={{
          display: "inline",
          px: 0.25,
          borderRadius: 0.5,
          backgroundColor: "warning.light",
          color: "warning.contrastText",
          fontWeight: 700,
        }}
      >
        {part}
      </Box>
    ) : (
      part
    ),
  );
};
